import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(async ({ detail }) => {
    if (detail?.didError) return;
    const header = document.querySelector('[data-master-header]');
    if (!header) return;
    const response = await fetch(`${header.dataset.cartUrl}.js`, { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('.master-cart-count').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
  }).catch(() => { /* The cart component displays errors; keep the last confirmed count. */ });
});

